import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Stellio JS</h1>
        <a href="https://github.com/thoshithaKaduru/stelliojs">
          Github Project Link
        </a>
      </header>
    </div>
  );
}

export default App;
